import CircularProgress from "@mui/material/CircularProgress";

const Spinner = ({ color = "#3FB498", size = 20 }) => (
  <CircularProgress size={size} sx={{ color: color }} />
);

export default Spinner;
